<script setup>
import { ref, watch } from "vue";
import { Head, Link, router } from "@inertiajs/vue3";
import debounce from "lodash/debounce";

import Datatables from "@/Shared/Tables/Datatables.vue";
import DatatableFooterWrapper from "@/Shared/Tables/DatatableFooterWrapper.vue";

import VAlert from "@/Shared/VAlert.vue";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VButtonCreate from "@/Shared/HeaderButton/VButtonCreate";
import VModalForm from "./_partials/VModalForm.vue";
import Swal from "sweetalert2";
import axios from "axios";
import VModalDetail from "./_partials/VModalDetail.vue";

let props = defineProps({
    additional: Object,
});

const { urlStore } = props.additional;

const isShowAlert = ref(true);
const isShowForm = ref(false);
const isShowDetail = ref(false);

const selectedRole = ref(null);

const urlSubmit = ref(urlStore);

const formType = ref("create");

const breadcrumbs = [
    {
        url: "#",
        label: "Role Management",
    },
];

const changePageLength = (value) => {
    geRoles({ per_page: value });
};

const onFilter = (value) => {
    geRoles({
        search_fields: value.search_fields,
        search_values: value.search_values,
        per_page: props.additional.filters.per_page ?? 20,
        order_by: value.order_by,
        order_type: value.order_type,
    });
};

const geRoles = (params) => {
    router.get(props.additional.urlIndex, params, {
        preserveState: true,
        replace: true,
    });
};

const openFormAdd = () => {
    formType.value = "create";
    urlSubmit.value = urlStore;
    selectedRole.value = null;
    isShowForm.value = true;
    isShowAlert.value = false;
};

const closeForm = () => {
    selectedRole.value = null;
    isShowForm.value = false;
    isShowAlert.value = false;
};

const closeDetail = () => {
    selectedRole.value = null;
    isShowDetail.value = false;
    isShowAlert.value = false;
};

const onSave = () => {
    selectedRole.value = null;
    isShowForm.value = false;
    isShowAlert.value = true;
};

const removeAction = async (value) => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) {
        return false;
    }

    router.post(value.url, { _method: "DELETE" });
};

const editAction = async (value) => {
    const response = await axios.get(value.urlFetch);

    selectedRole.value = response.data.data;

    urlSubmit.value = value.urlSubmit;

    formType.value = "edit";

    isShowForm.value = true;
    isShowAlert.value = false;
};

const showAction = async (value) => {
    const response = await axios.get(value.url);

    selectedRole.value = response.data.data;

    isShowDetail.value = true;
    isShowAlert.value = false;
};

const actionClick = (value) => {
    if (value.type == "delete") {
        removeAction(value);
    }

    if (value.type == "edit") {
        editAction(value);
    }

    if (value.type == "show") {
        showAction(value);
    }
};
</script>

<template>
    <Head>
        <title>User Access Role</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert v-if="!isShowForm && isShowAlert" />

        <div class="card">
            <div class="card-body">
                <div class="text-end mb-3">
                    <VButtonCreate @onClick="openFormAdd">
                        Add Roles
                    </VButtonCreate>
                </div>

                <div class="dataTables_wrapper dt-bootstrap5">
                    <Datatables
                        :columns="additional.columns"
                        :pagination="additional.roles"
                        :filters="additional.filters"
                        @onFilter="onFilter"
                        @onActionClick="actionClick"
                    />

                    <DatatableFooterWrapper
                        :pagination="additional.roles.meta"
                        :filters="additional.filters"
                        @onChange="changePageLength"
                    />
                </div>
            </div>
        </div>
    </div>

    <VModalForm
        v-if="isShowForm"
        :role="selectedRole"
        :menulist="additional.menulist"
        :urlSubmit="urlSubmit"
        :type="formType"
        :method="formType == 'create' ? 'POST' : 'PUT'"
        @onSave="onSave"
        @onCancel="closeForm"
    />

    <VModalDetail
        v-if="isShowDetail"
        :role="selectedRole"
        :menulist="additional.menulist"
        @onCancel="closeDetail"
    />
</template>
